const logo = {
  splashLogo: require("./logo/logo.png"),
  drawerLogo: require("./logo/logo.png"),
  appIcon: require("./logo/app_icon.png"),
};

const icon = {
  error: require("./icons/error.png"),
  notFound: require("./icons/not_found.png"),
  networkError: require("./icons/networkError.png"),
};

const gif = {
  wave: require("./gif/wave.gif"),
};

import TabBottomShape from "./svg/tab-bottom-shape.svg";
const svg = { TabBottomShape };

export { logo, icon, svg, gif };
